module.exports = __webpack_public_path__ + "img/news13_1.0323b6e4.jpg";